/* ============================================================
   GUG Cart — progressive enhancement for the branded cart page.
   Baseline works with NO JS (native cart form: url_to_remove links,
   name="update", name="checkout"). This layer adds:
     - quantity steppers (+/-)
     - instant remove + quantity change via the /cart/change.js API
       (updates totals in place, no full submit)
   Everything degrades gracefully: if a fetch fails, we fall back to a
   normal form submit / native remove link so the cart is never stuck.
   Theme-editor safe: re-binds on shopify:section:load.
   ============================================================ */
(function () {
  var CURRENCY_CACHE = null;

  function money(cents) {
    // Mirror Shopify's default money format using the shop's currency.
    // Falls back to a plain formatted number if Intl is unavailable.
    var amount = cents / 100;
    try {
      if (!CURRENCY_CACHE && window.Shopify && Shopify.currency) {
        CURRENCY_CACHE = Shopify.currency.active;
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: CURRENCY_CACHE || 'USD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function findSection() { return document.querySelector('[data-gugct]'); }

  function setBusy(section, on) {
    var grid = section.querySelector('[data-gugct-grid]');
    if (grid) grid.classList.toggle('is-busy', !!on);
  }

  // Re-render totals + per-line prices from a fresh cart object.
  function applyCart(section, cart) {
    if (cart.item_count === 0) { window.location.reload(); return; }
    // A removal shifts every later line's index, so our DOM->cart.items map
    // no longer holds. Reload to re-render the list correctly.
    var domCount = section.querySelectorAll('[data-gugct-item]').length;
    if (cart.items.length !== domCount) { window.location.reload(); return; }

    var sub = section.querySelector('[data-gugct-subtotal]');
    var tot = section.querySelector('[data-gugct-total]');
    if (sub) sub.textContent = money(cart.items_subtotal_price);
    if (tot) tot.textContent = money(cart.total_price);

    // cart.items order matches the DOM line order (1-based data-index).
    section.querySelectorAll('[data-gugct-item]').forEach(function (li) {
      var idx = parseInt(li.getAttribute('data-index'), 10) - 1;
      var it = cart.items[idx];
      if (!it) return;
      var priceEl = li.querySelector('.gugct-price-final');
      if (priceEl) {
        if (it.final_line_price === 0) {
          priceEl.textContent = 'Free';
          priceEl.classList.add('gugct-price-free');
        } else {
          priceEl.textContent = money(it.final_line_price);
          priceEl.classList.remove('gugct-price-free');
        }
      }
      var input = li.querySelector('[data-gugct-input]');
      if (input) input.value = it.quantity;
    });
  }

  // Change one line by its 1-based index via the Cart AJAX API.
  function changeLine(section, line, qty, fallback) {
    setBusy(section, true);
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart change failed'); return r.json(); })
      .then(function (cart) { applyCart(section, cart); setBusy(section, false); })
      .catch(function () { setBusy(section, false); if (fallback) fallback(); });
  }

  function bind(section) {
    if (!section || section.__gugctBound) return;
    section.__gugctBound = true;
    var form = section.querySelector('.gugct-form');

    // AJAX handles quantity changes, so the manual "Update cart" button is only
    // needed as the no-JS fallback. Hide it now that JS is active.
    var updateBtn = section.querySelector('[data-gugct-update]');
    if (updateBtn) updateBtn.style.display = 'none';

    // Quantity steppers
    section.querySelectorAll('[data-gugct-qty]').forEach(function (qty) {
      qty.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-step]');
        if (!btn) return;
        e.preventDefault();
        var input = qty.querySelector('[data-gugct-input]');
        var line = parseInt(input.getAttribute('data-line'), 10);
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-step'), 10));
        input.value = next;
        var dec = qty.querySelector('button[data-step="-1"]');
        if (dec) dec.disabled = next <= 1;
        changeLine(section, line, next, function () { if (form) form.submit(); });
      });
    });

    // Typed quantity change
    section.querySelectorAll('[data-gugct-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = parseInt(input.getAttribute('data-line'), 10);
        var next = Math.max(0, parseInt(input.value, 10) || 0);
        input.value = next;
        changeLine(section, line, next, function () { if (form) form.submit(); });
      });
    });

    // Remove links -> AJAX (set qty 0), fall back to the native href.
    section.querySelectorAll('[data-gugct-remove]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var line = parseInt(link.getAttribute('data-line'), 10);
        changeLine(section, line, 0, function () { window.location.href = link.getAttribute('href'); });
      });
    });

    bindSwap(section);
  }

  /* ---------- Edit -> Complete Edition swap ----------
     Accepting must never leave the customer paying for both: the Complete
     Edition goes in and the Edit line comes out in the same sequence, and the
     page only reloads once both calls have succeeded. If either call fails we
     leave the cart exactly as it was and say so, rather than half-swapping. */
  function bindSwap(section) {
    if (!section) return;
    var band = section.querySelector('[data-gugct-swap]');
    if (!band || band.__gugctSwapBound) return;
    band.__gugctSwapBound = true;

    var dismiss = band.querySelector('[data-gugct-swap-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        band.setAttribute('hidden', 'hidden');
        try { sessionStorage.setItem('gugctSwapDismissed', '1'); } catch (err) { /* private mode */ }
      });
    }
    try {
      if (sessionStorage.getItem('gugctSwapDismissed') === '1') band.setAttribute('hidden', 'hidden');
    } catch (err) { /* private mode */ }

    var accept = band.querySelector('[data-gugct-swap-accept]');
    if (!accept) return;
    accept.addEventListener('click', function () {
      var key = band.getAttribute('data-line-key');
      var variant = band.getAttribute('data-complete-id');
      if (!key || !variant) return;
      accept.disabled = true;
      accept.classList.add('is-busy');

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(variant), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('remove'); window.location.reload(); })
        .catch(function () {
          accept.disabled = false;
          accept.classList.remove('is-busy');
          var msg = band.querySelector('[data-gugct-swap-error]');
          if (!msg) {
            msg = document.createElement('p');
            msg.className = 'gugct-swap-error';
            msg.setAttribute('data-gugct-swap-error', '');
            band.appendChild(msg);
          }
          msg.textContent = "That didn't go through and your cart is unchanged. Refresh and try again, or add the Complete Edition from its product page.";
        });
    });
  }

  function init() { bind(findSection()); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector ? e.target.querySelector('[data-gugct]') : null;
    if (sec) { sec.__gugctBound = false; bind(sec); }
  });
})();
